export default function Automations() {
  const automations = [
    { title: "Buchungsbestätigung", desc: "Sofort nach neuer Buchung wird eine Bestätigung an den Gast versendet.", when: "Bei Buchungserstellung", status: "aktiv" },
    { title: "Check-in Link", desc: "3 Tage vor Anreise wird ein Link zum Online Check-in gesendet.", when: "3 Tage vor Anreise", status: "geplant" },
    { title: "Anreise-Erinnerung", desc: "Am Vortag der Anreise erhält der Gast eine kurze Erinnerung.", when: "1 Tag vor Anreise", status: "geplant" },
    { title: "Rechnung nach Abreise", desc: "Sofort nach Abreise wird eine Rechnung erzeugt und optional versendet.", when: "Bei Abreise", status: "geplant" },
    { title: "Bewertungsanfrage", desc: "3 Tage nach Abreise wird eine freundliche Bewertungsanfrage gesendet.", when: "3 Tage nach Abreise", status: "geplant" },
    { title: "Zahlungserinnerung", desc: "7 Tage nach Rechnungsstellung bei offenem Zahlungsstatus.", when: "7 Tage nach Rechnung", status: "geplant" },
  ];
  return (
    <div className="space-y-6" data-testid="automations-page">
      <div>
        <h1 className="text-3xl font-bold" style={{fontFamily:"'Work Sans',sans-serif"}}>Automatisierungen</h1>
        <p className="text-muted-foreground mt-1">Regeln für automatische Kommunikation und Aufgaben</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {automations.map(a => (
          <div key={a.title} className="msb-card" data-testid={`automation-${a.title}`}>
            <div className="flex justify-between items-start gap-2">
              <h3 className="text-lg font-semibold" style={{fontFamily:"'Work Sans',sans-serif"}}>{a.title}</h3>
              <span className={`status-pill ${a.status==="aktiv"?"bg-emerald-100 text-emerald-800":"bg-amber-100 text-amber-800"}`}>{a.status}</span>
            </div>
            <p className="text-sm text-muted-foreground mt-2">{a.desc}</p>
            <div className="text-xs uppercase tracking-widest text-muted-foreground mt-3">Trigger: {a.when}</div>
          </div>
        ))}
      </div>
      <div className="msb-card bg-muted/50">
        <p className="text-sm text-muted-foreground">
          Hinweis: In dieser Prototyp-Version können Nachrichten manuell aus dem Bereich <strong>Nachrichten</strong> versendet werden. Zeitgesteuerte Automatisierungen aktivieren wir gerne in der nächsten Ausbaustufe.
        </p>
      </div>
    </div>
  );
}
